export default "__VITE_ASSET__472c2d52__"